import React, { FC, ReactElement, memo } from 'react';
// Components
import Text from '../text';
// Resources
import { CreateMemberFamilyInput } from '../../core/apiTypes';
import { IconCommon } from '../../resources/images';
import ListItemWithRadio from '../list/ListItemWithRadio';

interface PassengerCardProps {
    passenger: CreateMemberFamilyInput;
    subtitle?: string;
    onSelect: (user: CreateMemberFamilyInput) => void;
    isSelected?: boolean;
}

const PassengerCard: FC<PassengerCardProps> = (props): ReactElement => {
    const { passenger, subtitle, isSelected, onSelect } = props;
    const { lastname, firstname, nickname } = passenger;

    const onSelectPassenger = () => {
        onSelect(passenger);
    };

    const renderSecondary = () => {
        if (!!nickname || subtitle) {
            return <Text.ShortRegularText14 component="span" text={nickname || subtitle} customColor="grey" />;
        }
        return null;
    };

    return (
        <ListItemWithRadio
            data={passenger}
            title={`${firstname} ${lastname}`}
            icon={IconCommon.UserOutline}
            subtitle={renderSecondary()}
            onSelect={onSelectPassenger}
            isSelected={isSelected}
        />
    );
};

export default memo(PassengerCard);
